import icon from 'vue-svgicon';

icon.register({
    'bold/dial-finger': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.079 14.779L18 12.956V7.5a2 2 0 0 0-4 0v8.461l-.827-1.138a1.546 1.546 0 0 0-1.2-.558l-.991.019a1.476 1.476 0 0 0-1.3 2.179l3.735 6.773A1.464 1.464 0 0 0 14.7 24h6.387a1.476 1.476 0 0 0 1.378-.989l1.52-6.68A.461.461 0 0 0 24 16.22a1.435 1.435 0 0 0-.921-1.441z"/><rect pid="1" width="4" height="3" rx=".5" ry=".5"/><rect pid="2" x="6" width="4" height="3" rx=".5" ry=".5"/><rect pid="3" y="5" width="4" height="3" rx=".5" ry=".5"/><rect pid="4" x="6" y="5" width="4" height="3" rx=".5" ry=".5"/><rect pid="5" y="10" width="4" height="3" rx=".5" ry=".5"/><rect pid="6" x="6" y="10" width="4" height="3" rx=".5" ry=".5"/><rect pid="7" x="12" width="4" height="3" rx=".5" ry=".5"/>`,
    },
});
